<template>
  <div class="politique">
      <h3>Politique de protection et d'utilisations des données</h3>
      <p>Les informations recueillies vous concernant ne seront utilisées qu’à des fins statistiques anonymisées à l’usage de l’État de Genève et du Pôle Métropolitain du Genevois Français. Il s’agit uniquement du nombre de Quiz réalisés.</p>
      <p>Votre adresse mail est uniquement destinée à vous permettre d’enregistrer les résultats du test. Elle ne sera en aucun cas utilisée à d’autres fins.</p>
      <p>Vous bénéficiez du droit d’effacement en vous adressant à <a href="mailto:info@quiz-metiers-transition-energetique.ch">info@quiz-metiers-transition-energetique.ch</a>.</p>
      
      <button class="btn-fermer" v-on:click="closeBtn">Fermer</button>

    </div>
</template>

<script>
export default {
  name: 'politiqueConfidentialite',

  methods: {
    closeBtn () {
      this.$emit('closePolitique')
      console.log('clicked')
    }
  }
}

</script>

<style lang="scss">
  .politique {
    padding: 20px;
    background-color: lightgrey;
    margin: 20px 0;
    text-align: left;
    font-size: 0.8em;

    .btn-fermer {
      background-color: #000;
      color: #fff;
      padding: 5px 10px;
      cursor: pointer;

      &:hover {

      }
    }
  }
</style>
